import * as yup from 'yup';

yup.setLocale({
    mixed: {
        required: 'Dieses Feld ist ein Pflichtfeld'
    }
});

export const utils = {
    string: yup.string(),
    array: yup.array().of(yup.string()).notRequired(),
    email: yup.string().email('Ungültige Email Adresse'),
    mailbox: yup.string().matches(/^([a-zA-Z0-9 ]+|)$/i, 'Ungültiges Postfach'),
    phone: yup
        .string()
        .test('is-valid-phone', 'Ungültige Telefonnummer', (value) => {
            if (value) {
                return /^(tel:)?\+?(\(?\d{1,5}\)?([\s-]?\d+)+)$/.test(value);
            }
            return true;
        })
        .notRequired(),
    website: yup.string().test('is-valid-website', 'Ungültige URL', (value) => {
        return (
            !value ||
            /^(https:\/\/|www\.)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+/.test(value)
        );
    })
};

export const waterSupplierAsPersonValidationSchema = yup.object({
    salutation: yup.string(),
    firstname: yup.string().required('Vorname ist ein Pflichtfeld.'),
    lastname: yup.string().required('Nachname ist ein Pflichtfeld.'),
    federalState: yup.string().required('Bundesland ist ein Pflichtfeld.'),
    isLegalOperator: yup.boolean().required('Bundesland ist ein Pflichtfeld.')
});

export const waterSupplierAsCompanyValidationSchema = yup.object({
    type: yup.number().required('Typ ist ein Pflichtfeld.'),
    name: yup.string().required('Name ist ein Pflichtfeld.'),
    federalState: yup
        .string()
        .required('Juristischer Betreiber? ist ein Pflichtfeld'),
    isLegalOperator: yup
        .boolean()
        .required('Juristischer Betreiber? ist ein Pflichtfeld')
});

export const object = yup.object;
export const string = yup.string;
